import { graphql } from '../graphql';
import { useRequest } from '../hooks/useRequest';
export const SEND_MESSAGE_READ_STATUS = graphql(`
  mutation SendMessageReadStatus(
    $id: String!
    $messageId: String!
    $timestamp: String!
  ) {
    sendMessageReadStatus(
      input: { id: $id, messageId: $messageId, timestamp: $timestamp }
    )
  }
`);
const variables = {};
export const useSendReadStatusRequest = () => {
    return useRequest(SEND_MESSAGE_READ_STATUS, variables);
};
